import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { G_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Installment_View_Model';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { SavePurchaseMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { E_G_EPSStatusType } from 'src/app/viewmodels/g-purchase/E_G_EPSStatusType';
@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent implements OnInit {

  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public vm: SavePurchaseMasterRequest = new SavePurchaseMasterRequest();
  public vmI: G_Installment_View_Model = new G_Installment_View_Model();
  public vmListItems: any = [];
  public invoicesList: any = [];

  dataTable: any;
  @Input('dataTable') table;
  dtOption: any = {};
  public component_Title = 'Purchase';
  public exportFormat: string = 'csv';
  startDate: any = null;
  endDate: any = null;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  pId: number = null;

  public deleteId: string;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.pId = E_G_EPSStatusType.Purchase_Slip;
    this.getList();
    $('table.display').DataTable();
    //   this.getList();
    //   this.dtOption = {
    //     "paging":   false,
    //     "searching": false,
    //     "info": false,
    // };
    // $(() =>{
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }

  ngAfterViewInit() {
  }


  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gPurchaseService.getListById("GPurchase", "GetPurchaseRequisitesAsync", this.p, this.size, search, this.orderBy, this.sort, this.pId)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }


  // getList() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this._uow.purchaseService.GetList().subscribe((res: any) => {
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;
  //     this.vm = res.DtlList;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //   });
  // }

  navigateClick() {
    debugger
    this._router.navigate(['/purchase-dtl-view', { id: this.vm.id }]);
  }

  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.purchaseService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //       this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     });
  //   } else {
  //     this.getList();
  //   }
  // }

  // getSortIndexList(sIndex) {
  //   debugger
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.purchaseService.GetPagedResult(0, 50, null, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //   });
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
      this.vm.transactionDate = this._uow.defaultService.CutTimeZone(this.vm.transactionDate);
    } else {
      this.vm = undefined;
    }
  }

  openAttachmentModal(template: TemplateRef<any>, b) {
    debugger
    this._uow.gPurchaseService.GetGPurchaseByIdAsync(b).subscribe((res: any) => {
      this.invoicesList = res.invoicesList;
      console.log(this.invoicesList);
    });
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  // extrnal components
  onItemSubmitted(e) {
    document.location.reload();
    console.log(e);
    if (e === true) {
      this.vm = new SavePurchaseMasterRequest();
      this.getList();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gPurchaseService.DeletePurchaseRequisiteAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.spinner.hide();
      Swal.fire(
        'Deleted!',
        'Purchase Deleted!',
        'success'
      )
      this.modalRef.hide();
    }, (err) => {
      Swal.fire(
        'Failure!',
        'Purchase Not Deleted!',
        'error'
      )
      console.log(err);
      this.spinner.hide();
    });
  }

  openExportModel(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }


  exportToExcel() {
    debugger;
    this.spinner.show();
    // var obj = new ExportExcel();
    // obj = {

    //   StartDate: this.startDate,
    //   EndDate: this.endDate,
    //   Format: this.exportFormat
    // }
    this._uow.gPurchaseService.GetPurchaseExportAsync(this.startDate, this.endDate).subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRef.hide();
    },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          'Record was not found.',
          'error'
        )
      });
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }


  // exportToExcel() {
  //   debugger;
  //   this.spinner.show();
  //   var obj = new ExportExcel();
  //   obj = {
  //     StartDate: this.startDate,
  //     EndDate: this.endDate,
  //     Format: this.exportFormat
  //   }
  //   this._uow.purchaseService.ExportPurchaseList(obj).subscribe((res: any) => {
  //     debugger;

  //     const blob = new Blob([res], { type: res.type });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `PurchaseData_${new Date().toISOString().split('T')[0]}.${this.exportFormat.toLowerCase()}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);

  //     this.spinner.hide();
  //     this.modalRef.hide();
  //   },
  //     (error) => {
  //       this._uow.logger.log(error);
  //       this.spinner.hide();
  //       Swal.fire(
  //         'Failure!',
  //         'Network Issue!',
  //         'error'
  //       )
  //     });
  // }

}
